import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/58ac620c/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/overflowmenu--basic",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-overflow-menu--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvoverflowmenu--default",
      Vanilla: "http://vue.carbondesignsystem.com/?path=/story/components-cvoverflowmenu--default"
    }} knobs={{
      OverflowMenuItem: ["disabled", "hasDivider", "isDelete"]
    }} mdxType="ComponentDemo">
  {`
<OverflowMenu>
  <OverflowMenuItem
    itemText="Option 1"
    primaryFocus
  />
  <OverflowMenuItem
    itemText="Option 2 is an example of a really long string and how we recommend handling this"
    requireTitle
  />
  <OverflowMenuItem itemText="Option 3" />
  <OverflowMenuItem itemText="Option 4" hasDivider isDelete/>
</OverflowMenu>
  `}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      